import React from 'react'
import PropTypes from 'prop-types'
import Alert from '../../../../molecules/Alert'

const OfficeHourAlert = ({ isReceptionDesk }) => {
  return (
    <Alert type="info" className="md:w-3/5" border>
      {isReceptionDesk ? (
        <ul className="list-outside list-disc ml-4">
          <li>
            El horario de atención debe ser continuo y de al menos 8 horas, de acuerdo al Art. 149 de la Ley N° 27444.
          </li>
          <li>
            La entidad está obligada a derivar internamente la solicitud al área competente el mismo día hábil en que se
            recibe a través de la mesa de partes digital.
          </li>
          <li>
            Esto no restringe el derecho del ciudadano a presentar solicitudes las 24/7, ni cambia la fecha y hora legal
            del registro.
          </li>
        </ul>
      ) : (
        <p>
          El horario de atención no restringe el derecho del ciudadano a presentar solicitudes las 24/7, ni cambia la
          fecha y hora legal del registro.
        </p>
      )}
    </Alert>
  )
}

export default OfficeHourAlert

OfficeHourAlert.propTypes = {
  isReceptionDesk: PropTypes.bool
}
